import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__ from "class-variance-authority";
import * as __WEBPACK_EXTERNAL_MODULE__helpers_mapClass_js_8e73aa1a__ from "../helpers/mapClass.js";
import * as __WEBPACK_EXTERNAL_MODULE__shared_shared_prop_js_bc881259__ from "../shared/shared.prop.js";
import * as __WEBPACK_EXTERNAL_MODULE__flex_prop_js_7e6feb43__ from "./flex.prop.js";
import * as __WEBPACK_EXTERNAL_MODULE__Flex_module_js_e068daa9__ from "./Flex.module.js";
const flexClasses = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)(__WEBPACK_EXTERNAL_MODULE__Flex_module_js_e068daa9__["default"].flex, {
    variants: {
        direction: (0, __WEBPACK_EXTERNAL_MODULE__helpers_mapClass_js_8e73aa1a__.mapClass)(__WEBPACK_EXTERNAL_MODULE__flex_prop_js_7e6feb43__.directionValues, 'flexDirection'),
        display: (0, __WEBPACK_EXTERNAL_MODULE__helpers_mapClass_js_8e73aa1a__.mapClass)(__WEBPACK_EXTERNAL_MODULE__flex_prop_js_7e6feb43__.displayValues, 'display'),
        align: (0, __WEBPACK_EXTERNAL_MODULE__helpers_mapClass_js_8e73aa1a__.mapClass)(__WEBPACK_EXTERNAL_MODULE__flex_prop_js_7e6feb43__.alignValues, 'flexAlign'),
        justify: (0, __WEBPACK_EXTERNAL_MODULE__helpers_mapClass_js_8e73aa1a__.mapClass)(__WEBPACK_EXTERNAL_MODULE__flex_prop_js_7e6feb43__.justifyValues, 'justifyContent'),
        gap: (0, __WEBPACK_EXTERNAL_MODULE__helpers_mapClass_js_8e73aa1a__.mapClass)(__WEBPACK_EXTERNAL_MODULE__flex_prop_js_7e6feb43__.gapValues, 'gap'),
        wrap: (0, __WEBPACK_EXTERNAL_MODULE__helpers_mapClass_js_8e73aa1a__.mapClass)(__WEBPACK_EXTERNAL_MODULE__flex_prop_js_7e6feb43__.wrapValues, 'flexWrap'),
        ...__WEBPACK_EXTERNAL_MODULE__shared_shared_prop_js_bc881259__.sharedStyles.cx
    },
    defaultVariants: {
        direction: 'column'
    }
});
function Flex(props) {
    const { direction, display, align, justify, wrap, gap, cx, children, ...flexProps } = props;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        ...flexProps,
        className: flexClasses({
            direction,
            display,
            align,
            justify,
            wrap,
            gap,
            ...cx
        }),
        children: children
    });
}
export { Flex as default };

//# sourceMappingURL=Flex.js.map